export enum AssociationRoleEnum {
    AssociationAdmin = 1,
    AssociationGroupAdmin = 2,
}

export enum Gender {
    Female = 1,
    Male = 2,
}

export enum AspNetRole {
    SystemAdmin = 1,
    MunicipalityAdmin = 2,
    AssociationUser = 3,
}

export enum ApplicationSetting {
    Municipality = 1,
    IsSSNMandatory = 2,
    FormatOfDateOfBirth = 3,
    ZipCodeVisibleAndMandatory = 4,
    CityVisibleAndMandatory = 5,
    MailO365ClientId = 6,
    MailO365TenantId = 7,
    MailO365ServerUserName = 8,
    MailO365ServerUserPassword = 9,
    AccessibilityStatementUrl = 10,
    MunicipalityName = 11,
    MunicipalityLogo = 12,
    ApiKey = 13,
    ThemePrimary = 14,
    ThemeAccent = 15,
    ThemeSecondary = 16,
    ThemeSuccess = 17,
    ThemeInfo = 18,
    ThemeWarning = 19,
    ThemeError = 20,
    MaxNumberOfAssociations = 21,
}

export enum Frequencies {
    EveryWeek = 1,
    EveryOtherWeek = 2,
    EveryFourthWeek = 3,
}

export enum OccasionTypes {
    Training = 1,
    Game = 2,
    Meeting = 3,
    Other = 4,
}

export enum BatchStates {
    Pending = 1,
    Running = 2,
    Done = 3,
    Error = 4,
}

export enum ImportPersonStatus {
    New = 1,
    IsChanged = 2,
    ExistAndNothingChanged = 3,
    SocialSecurityNoInvalid = 4,
    AssociationUserAndEmailChanged = 5,
}

export enum LogLevels {
    Trace = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Critical = 5,
    None = 6,
}

export enum LogTypes {
    System = 1,
    User = 2,
    Association = 3,
    Group = 4,
    Person = 5,
    Occasion = 6,
    ExportFile = 7,
    Batch = 8,
}